module.exports = __webpack_public_path__ + "static/media/download.a89f4933.svg";